export default {
  cross: [
    [-0.5, -1], [0.5, -1], [0.5, -0.5], [1, -0.5], [1, 0.5], [0.5, 0.5], [0.5, 1], [-0.5, 1], [-0.5, 0.5], [-1, 0.5], [-1, -0.5], [-0.5, -0.5], [-0.5, -1], [-0.5, -1]
  ],
  'cross-sharp': [
    [0, -1], [0.2, -0.2], [1, 0], [0.2, 0.2], [0, 1], [-0.2, 0.2], [-1, 0], [-0.2, -0.2], [0, -1]
  ],
  diamond: [
    [0, -1], [1, 0], [0, 1], [-1, 0], [0, -1], [0, -1]
  ],
  'triangle-up': [
    [0, -1], [1, 1], [-1, 1], [0, -1], [0, -1]
  ],
  'triangle-down': [
    [1, -1], [0, 1], [-1, -1], [1, -1], [1, -1]
  ],
  'triangle-right': [
    [-1, -1], [1, 0], [-1, 1], [-1, -1], [-1, -1]
  ],
  'triangle-left': [
    [1, -1], [-1, 0], [1, 1], [1, -1], [1, -1]
  ],
  star4: [
    [0, 0.71], [1, 1], [0.71, 0], [1, -1], [0, -0.71], [-1, -1], [-0.71, 0], [-1, 1], [0, 0.71], [0, 0.71]
  ],
  star5: [
    [0, 0.5], [0.6, 0.8], [0.5, 0.1], [1, -0.3], [0.3, -0.4], [0, -1], [-0.3, -0.4], [-1, -0.3], [-0.5, 0.1], [-0.6, 0.8], [0, 0.5], [0, 0.5]
  ],
  star: [
    [0, 0.5], [0.6, 0.8], [0.5, 0.1], [1, -0.3], [0.3, -0.4], [0, -1], [-0.3, -0.4], [-1, -0.3], [-0.5, 0.1], [-0.6, 0.8], [0, 0.5], [0, 0.5]
  ],
  star6: [
    [0, 0.58], [0.5, 1], [0.43, 0.29], [1, 0], [0.43, -0.29], [0.5, -1], [0, -0.58], [-0.5, -1], [-0.43, -0.29], [-1, 0], [-0.43, 0.29], [-0.5, 1], [0, 0.58]
  ],
  star8: [
    [0, 0.54], [0.41, 1], [0.38, 0.38], [1, 0.41], [0.54, 0], [1, -0.41], [0.38, -0.38], [0.41, -1], [0, -0.54], [-0.41, -1], [-0.38, -0.38], [-1, -0.41], [-0.54, 0], [-1, 0.41], [-0.38, 0.38], [-0.41, 1], [0, 0.54]
  ],
  pentagon: [
    [-1, -0.24], [0, -1], [1, -0.24], [0.62, 1], [-0.62, 1], [-1, -0.24], [-1, -0.24]
  ],
  hexagon: [
    [-1, 0], [-0.57, -1], [0.57, -1], [1, 0], [0.57, 1], [-0.57, 1], [-1, 0], [-1, 0]
  ],
  heptagon: [
    [-1, 0.29], [-0.8, -0.6], [0, -1], [0.8, -0.6], [1, 0.29], [0.45, 1], [-0.45, 1], [-1, 0.29], [-1, 0.29]
  ],
  septagon: [
    [-1, 0.29], [-0.8, -0.6], [0, -1], [0.8, -0.6], [1, 0.29], [0.45, 1], [-0.45, 1], [-1, 0.29], [-1, 0.29]
  ],
  octagon: [
    [-1, -0.41], [-0.41, -1], [0.41, -1], [1, -0.41], [1, 0.41], [0.41, 1], [-0.41, 1], [-1, 0.41], [-1, -0.41], [-1, -0.41]
  ],
  nonagon: [
    [0.35, -1], [0.88, -0.55], [1, 0.15], [0.65, 0.76], [0, 1], [-0.65, 0.76], [-1, 0.15], [-0.88, -0.55], [-0.35, -1], [0.35, -1], [0.35, -1]
  ],
  decagon: [
    [-1, 0], [-0.81, -0.62], [-0.31, -1], [0.31, -1], [0.81, -0.62], [1, 0], [0.81, 0.62], [0.31, 1], [-0.31, 1], [-0.81, 0.62], [-1, 0], [-1, 0]
  ]
}
